export default __webpack_public_path__ + "static/mesh-ff51c7212d45675416426d74d67976d7.svg";